module.exports = __webpack_public_path__ + "cc4711b8a72e85c626872e03aa4b86a4.jpg";